import { render } from "./multitask.vue?vue&type=template&id=bb057a60&scoped=true"
import script from "./multitask.vue?vue&type=script&lang=js"
export * from "./multitask.vue?vue&type=script&lang=js"

import "./multitask.vue?vue&type=style&index=0&id=bb057a60&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb057a60"]])

export default __exports__